// src/components/layout/LeaderPreviewBanner.tsx
import { X } from "lucide-react";

export function LeaderPreviewBanner() {
  return (
    <div
      className="sticky top-0 z-50 flex items-center gap-3 px-4 py-2.5 text-sm border-b"
      style={{ background: "hsl(263, 45%, 16%)", borderColor: "hsl(263, 40%, 24%)" }}
    >
      <span className="h-2 w-2 rounded-full bg-primary animate-pulse flex-shrink-0" />
      <span className="flex-1 text-muted-foreground">
        <span className="font-semibold text-foreground">Leader preview</span>
        {" - "}You're viewing a sample of what leaders see in Coach Veera. Data is illustrative.
      </span>
      <button
        type="button"
        onClick={() => window.close()}
        className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
      >
        Close preview <X className="h-3 w-3" />
      </button>
    </div>
  );
}
